import { Pipe, PipeTransform } from '@angular/core';

type unit = 'm' | 'km';

@Pipe({
  name: 'distance'
})
export class DistancePipe implements PipeTransform {

  private readonly units: unit[] = ['m', 'km'];

  transform(meter: number, precision: number = 2): string {
    const threshold = 1000;
    let unitIndex = 0;
    while ((meter > (threshold - 1)) && (unitIndex < (this.units?.length - 1))) {
      meter /= threshold;
      unitIndex++;
    }
    const unit = this.units?.[unitIndex];
    return meter ? `${meter.toFixed(precision)}${unit}` : '';
  }

}
